/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * the package to which the courses belong, for now adults to \'null\', juniors to \'YOUNG_LEARNER_CAMPS\'
 */
export const ProductPackageApiDto = {
  EMPTY: 'EMPTY',
  YOUNG_LEARNER_CAMPS: 'YOUNG_LEARNER_CAMPS',
  YOUNG_ADULTS: 'YOUNG_ADULTS',
} as const;
export type ProductPackageApiDto = (typeof ProductPackageApiDto)[keyof typeof ProductPackageApiDto];
